import { render, staticRenderFns } from "./EntityDataDocuments.vue?vue&type=template&id=01361f59&scoped=true"
import script from "./EntityDataDocuments.vue?vue&type=script&lang=js"
export * from "./EntityDataDocuments.vue?vue&type=script&lang=js"
import style0 from "./EntityDataDocuments.vue?vue&type=style&index=0&id=01361f59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01361f59",
  null
  
)

export default component.exports